<footer *ngIf="display">
    <div class="bottom_div">
        <div class="logo_div">
            <img src=" ../../assets/images/CLVT_Logo.svg" aria-label="Clarivate Logo" width="158">
            <p class="copyright">© {{currentYear}} Clarivate. All rights reserved.</p>
        </div>
        <div class="link_div">
            <a [href]="contactUsUrl" class="links" title="Contact Us" target="_blank" rel="noopener noreferrer" >Contact Us</a>
            <a [href]="termsAndConditionsUrl" class="links" title="Terms and Conditions" target="_blank" rel="noopener noreferrer" >Terms and Conditions</a>
            <a [href]="accessibilityUrl" class="links" title="Terms and Conditions" target="_blank" rel="noopener noreferrer">Accessibility</a>
            <!-- OneTrust Cookies Settings button start -->
            <button class="ot-sdk-show-settings btn btn-link btn-action">Cookie Settings</button>
            <!-- OneTrust Cookies Settings button end -->
        </div>
    </div>
</footer>
